import { render, staticRenderFns } from "./Collaboration.vue?vue&type=template&id=245711fb&scoped=true&"
import script from "./Collaboration.vue?vue&type=script&lang=js&"
export * from "./Collaboration.vue?vue&type=script&lang=js&"
import style0 from "./Collaboration.vue?vue&type=style&index=0&id=245711fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245711fb",
  null
  
)

export default component.exports